import { DeepLinkUrls } from '@shared/enums/ScheduledNotificationType';
import { useTranslation } from 'react-i18next';

export const useDeepLinkUrlLabel = (): Record<DeepLinkUrls, string> => {
  const { t } = useTranslation();
  return {
    [DeepLinkUrls.CustomerCRD]:
      t(($) => $.notificationBuilder.deepLinkUrls.customerCrd),
    [DeepLinkUrls.CustomerWallet]:
      t(($) => $.notificationBuilder.deepLinkUrls.customerWallet),
    [DeepLinkUrls.CustomerPromotions]:
      t(($) => $.notificationBuilder.deepLinkUrls.customerPromotions),
  };
};
